<template>
  <div id="bottom" class="seasidetms_color_scheme_footer">
    <div class="bottom_bg">
      <div class="bottom_outer">
        <div class="bottom_inner sidebar_layout_14141414">
          <FooterCategoriesMenu />
          <FooterMainMenu />
          <FooterInfoMenu />
          <NetpeakFooter />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FooterCategoriesMenu from '@/components/footer/FooterCategoriesMenu'
import FooterMainMenu from '@/components/footer/FooterMainMenu'
import FooterInfoMenu from '@/components/footer/FooterInfoMenu'
import NetpeakFooter from '@/components/netpeak/NetpeakFooter'

export default {
  name: 'MainFooter',
  components: {
    FooterCategoriesMenu,
    FooterMainMenu,
    FooterInfoMenu,
    NetpeakFooter,
  },
}
</script>

<style></style>
